<template>
  <div>
    <div class="blackout" @click="$emit('close')" @mouseenter="$emit('close')">
    </div>
    <div
      class="info"
      :style="{
        'background-color': project.infoBackgroundColor,
        'color': project.infoTextColor,
        'font-family': project.textFont,
        'font-size': project.infoTextSize,
      }"
    >
      <button type="button" class="close" aria-label="Close information" @click="$emit('close')">
        <i
          class="icon ion-md-close-circle-outline"
          aria-hidden="true"
        ></i>
      </button>
      <div v-html="info"></div>
      <section
        v-if="safeQuotes.length"
        class="quote-attributions"
        aria-labelledby="quote-attributions-heading"
      >
        <h2 id="quote-attributions-heading">QUOTES &amp; AUTHORS</h2>
        <ol>
          <li v-if="safeCredit" class="artwork-credit">
            <span class="attribution-text">{{ safeCredit.title }}</span><br>
            <span class="attribution-author">-- {{ safeCredit.author }}</span>
          </li>
          <li v-for="quote in safeQuotes" :key="quote.id" class="quote-attribution">
            <span class="attribution-text">{{ quote.quote }}</span><br>
            <span v-if="quote.quoteAuthor" class="attribution-author">
              -- {{ quote.quoteAuthor }}
            </span>
          </li>
        </ol>
      </section>
      <section
        v-if="safeContributors.length"
        class="contributors"
        aria-labelledby="contributors-heading"
      >
        <h2 id="contributors-heading">QUOTE CONTRIBUTORS</h2>
        <ul>
          <li v-for="(name, index) in safeContributors" :key="`${index}-${name}`">
            {{ name }}
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
const { safeContributorNames } = require('@/lib/quote-contributors');
const { safeQuoteAttributions, safeArtworkCredit } = require('@/lib/quote-attributions');

export default {
  name: 'Info',
  computed: {
    safeQuotes() {
      return safeQuoteAttributions(this.quotes);
    },
    safeCredit() {
      return safeArtworkCredit(this.artworkCredit);
    },
    safeContributors() {
      return safeContributorNames(this.contributors);
    },
  },
  props: {
    quotes: {
      type: Array,
      default: () => [],
    },
    artworkCredit: {
      type: Object,
      default: null,
    },
    info: {
      type: String,
    },
    project: {
      type: Object,
      default: () => {},
    },
    contributors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.blackout {
  height: 9000px;
  width: 100%;
  z-index: 5;
}
.info {
  background-color: #fff;
  height: 98%;
  right: 10px;
  top: 10px;
  overflow: scroll;
  padding: 5px;
  padding-right: 15px;
  position: absolute;
  width: 300px;
  max-width: calc(100vw - 20px);
  box-sizing: border-box;
  z-index: 6;
  ol {
    padding-left: 15px;
    text-align: left;
  }
  /*@media (max-width: 767px) {*/
  /*  height: 84%;*/
  /*}*/
}

.close {
  background: transparent;
  border: 0;
  color: inherit;
  cursor: pointer;
  font-size: 1.5rem;
  right: 10px;
  top: 7px;
  position: fixed;
}
.close:focus-visible {
  outline: 2px solid currentColor;
}
.quote-attributions {
  font-size: 14px;
  margin-top: 24px;
  // Keep scrolled quote lines out from beneath the existing fixed close button.
  padding-right: 24px;
  text-align: left;

  h2 {
    font-size: inherit;
    font-weight: bold;
  }

  ol {
    list-style: decimal outside;
    padding-left: 28px;
    margin-right: 0;
  }

  li {
    margin-bottom: 8px;
    overflow-wrap: anywhere;
  }

  .attribution-text {
    white-space: pre-wrap;
  }
}
.contributors {
  border-top: 1px solid currentColor;
  margin-top: 24px;
  padding-top: 14px;
  text-align: left;

  h2 {
    font-size: inherit;
    font-weight: bold;
    text-align: center;
  }

  ul {
    columns: 1;
    list-style-position: inside;
    margin: 0;
    padding: 0;
  }

  li {
    break-inside: avoid;
    overflow-wrap: anywhere;
  }
}
</style>
